import {Component, NgZone, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'db-smooch-alternative',
    templateUrl: './smooch-alternative.component.html',
    styleUrls: ['./smooch-alternative.component.scss'],
    standalone: false
})
export class SmoochAlternativeComponent implements OnInit {
  messageForm: FormGroup = this._fb.group({
    message_meta: '{"test":"hello"}',
    conversation_meta: '{"test":"hello"}',
    message: ['test', Validators.required]
  });

  constructor(
    private ngZone: NgZone,
    private _fb: FormBuilder
  ) {

  }

  ngOnInit(): void {
  }

  sendMessage() {
    if (this.messageForm.invalid) {
      return;
    }
    const formData = this.messageForm.getRawValue();
    window['Smooch']?.createConversation({
      messages: [
        {
          text: formData.message,
          type: 'text',
          metadata: JSON.parse(formData.message_meta || '{}'),
        },
      ],
      metadata: JSON.parse(formData.conversation_meta || '{}')
    }).then(() => {
      window['Smooch']?.open();
    });
  }
}
